import React from 'react'
import { Link } from 'react-router-dom'
import GoogleSignInButton, { DiscordSignInButton, MicrosoftSignInButton } from '../components/GoogleSignInButton'
import AnimatedBackground from '../components/AnimatedBackground'
import GlassCard from '../components/UI/GlassCard'
import FormField from '../components/Forms/FormField'
import Divider from '../components/UI/Divider'
import LoadingSpinner from '../components/UI/LoadingSpinner'
import { useAuth } from '../hooks/useAuth'
import { useForm } from '../hooks/useForm'

const Login = () => {
    const { login, isLoading, error, clearError } = useAuth()
    const { values, handleChange, handleSubmit } = useForm(
        { email: "", password: "" },
        login,
        clearError
    )

    return (
        <div className="min-h-screen relative flex items-center justify-center p-4">
            <AnimatedBackground />
            <div className="w-full max-w-md">
                {/* Logo/Brand Section */}
                <div className="text-center mb-8">
                    <h1 className="text-4xl font-bold text-white mb-2">Main Stage</h1>
                    <p className="text-gray-300">Welcome back to your creative space</p>
                </div>

                {/* Login Form */}
                <GlassCard>
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <FormField
                            type="email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            label="Email Address"
                            placeholder="Enter your email"
                            autoComplete="email"
                            required
                        />

                        <FormField
                            type="password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            label="Password"
                            placeholder="Enter your password"
                            autoComplete="current-password"
                            required
                        />

                        {error && (
                            <div className="bg-red-500/20 border border-red-500/50 text-red-200 px-4 py-3 rounded-xl text-sm">
                                {error}
                            </div>
                        )}

                        <div className="text-right">
                            <Link to="#" className="text-sm text-purple-300 hover:text-purple-200 transition-colors duration-300">
                                Forgot your password?
                            </Link>
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                        >
                            {isLoading ? <LoadingSpinner text="Signing in..." /> : "Sign In"}
                        </button>

                        <Divider text="or continue with" />

                        <div className="flex flex-col gap-3">
                            <GoogleSignInButton />
                            <DiscordSignInButton />
                            <MicrosoftSignInButton />
                        </div>

                        <Divider text="New to Main Stage?" />

                        <Link
                            to="/register"
                            className="w-full block text-center bg-white/10 hover:bg-white/20 text-white font-semibold py-3 px-6 rounded-xl border border-white/20 hover:border-white/40 transition-all duration-300 hover:shadow-lg"
                        >
                            Create Account
                        </Link>
                    </form>
                </GlassCard>

                {/* Footer */}
                <div className="text-center mt-8 text-gray-400 text-sm">
                    <p>© 2024 Main Stage. Built for creators.</p>
                </div>
            </div>
        </div>
    )
}

export default Login